/**
 * Workspace State Utility
 *
 * Simple module-level state for the current workspace ID.
 * This avoids circular dependencies between contexts and services.
 */

let currentWorkspaceId: string | null = null;

/**
 * Get the current workspace ID
 * Used by api.service.ts to add workspaceId to requests
 */
export function getWorkspaceId(): string | null {
  return currentWorkspaceId;
}

/**
 * Set the current workspace ID
 * Called by WorkspaceContext when workspace changes
 */
export function setWorkspaceId(id: string | null): void {
  currentWorkspaceId = id;
}
